<div class="modal-header">
  <strong>{{ 'document.hint_h' | translate }}</strong>
  <rs-web-icon
    (click)="migrateDocuments(false)"
    [icon]="immomioIconName.Close"
    [style.cursor]="'pointer'"
    [size]="16"
  ></rs-web-icon>
</div>
<div class="modal-body">
  <p>{{ 'document.desc_1_l' | translate }}</p>
  <p>{{ 'document.desc_2_l' | translate }}</p>
</div>
<div class="modal-footer">
  <button im-button class="primary" (click)="migrateDocuments(true)">
    {{ 'document.button_markall_l' | translate }}
  </button>
  <button im-button class="inverted" (click)="migrateDocuments(false)">
    {{ 'document.button_close_l' | translate }}
  </button>
</div>
